window.addEventListener('load', (event) => {
    var triggers = document.querySelectorAll('.js__hover-trigger');
    const mediaQ = window.matchMedia("(min-width: 1200px)");
    var hoverLinks = document.querySelectorAll('.js__addhover');

    function setOpen (e) {e.target.setAttribute("open", "");}
    function setClose (e) {e.target.removeAttribute("open");}
    function setGrandparentClose (e) {e.target.parentNode.parentNode.removeAttribute("open");}
    function handleMediaQ(e) {
        if (e.matches) {
            triggers.forEach(function(trigger) {
                trigger.addEventListener('mouseenter', setOpen);
                trigger.addEventListener('mouseleave', setClose);
                trigger.querySelector('.fls-header__subnav').addEventListener('mouseleave', setGrandparentClose);
            });

            hoverLinks.forEach(function(link) {
                link.classList.remove('fls-header__nav-link--has-children');
            });

        } else {
            triggers.forEach(function(trigger) {
                trigger.removeEventListener('mouseenter', setOpen);
                trigger.removeEventListener('mouseleave', setClose);
                trigger.querySelector('.fls-header__subnav').removeEventListener('mouseleave', setGrandparentClose);
            });

            hoverLinks.forEach(function(link) {
                link.classList.add('fls-header__nav-link--has-children');
            });
        }
    }

    mediaQ.addEventListener('change', handleMediaQ);
    handleMediaQ(mediaQ);

});